export const ProductTypes = {
    TypeBalcon: "balcon",
    SubtypeBalcon_P: "pbalcon",
    SubtypeBalcon_French: "frenchbalcon",

    TypeLattice: "lattice",
};